import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/api/api.service';
import { SPECIALTIES_ENDPOINTS } from 'src/app/core/api/endpoints/specialties.endpoints';
import {
  CreateSpecialtyDto,
  Specialty,
  SpecialtyListResponse,
  SpecialtyQueryParams,
  UpdateSpecialtyDto,
} from '../../models/specialty.model';

@Injectable({
  providedIn: 'root',
})
export class SpecialtiesService {
  private api = inject(ApiService);

  getSpecialties(params?: SpecialtyQueryParams): Observable<SpecialtyListResponse> {
    return this.api.get(SPECIALTIES_ENDPOINTS.V2.SPECIALIZATIONS, {
      params: params || {},
    });
  }

  getSpecialtyById(id: number | string): Observable<Specialty> {
    return this.api.get(SPECIALTIES_ENDPOINTS.V2.SPECIALIZATION_BY_ID(id));
  }

  createSpecialty(data: CreateSpecialtyDto): Observable<Specialty> {
    return this.api.post(SPECIALTIES_ENDPOINTS.V2.SPECIALIZATIONS, data);
  }

  updateSpecialty(id: number | string, data: UpdateSpecialtyDto): Observable<Specialty> {
    return this.api.put(SPECIALTIES_ENDPOINTS.V2.SPECIALIZATION_BY_ID(id), data);
  }

  deleteSpecialty(id: number | string): Observable<void> {
    return this.api.delete(SPECIALTIES_ENDPOINTS.V2.SPECIALIZATION_BY_ID(id));
  }
}
